var App = App || {};

App.RoadmapJourney = (function ($) {
    'use strict';

    function init() {

        const maxLength = DescMaxLength;

        $(".guidance-content").each(function () {
            const $desc = $(this).find(".guidance-content-desc");
            const fullText = $desc.text().trim();

            if (fullText.length > maxLength) {
                const shortText = fullText.substring(0, maxLength) + "...";
                $desc.data("full", fullText).data("short", shortText);
                $desc.text(shortText);
                $(this).find(".read-more-link").show();
            } else {
                $(this).find(".read-more-link").hide();
            }
        });

        $(".read-more-link").on("click", function (e) {
            e.preventDefault();
            const $link = $(this);
            const $container = $link.closest(".guidance-content");
            const $desc = $container.find(".guidance-content-desc");

            const isExpanded = $link.hasClass("expanded");

            if (isExpanded) {
                $desc.text($desc.data("short"));
                $link.text("Read More +").removeClass("expanded");
            } else {
                $desc.text($desc.data("full"));
                $link.hide();
            }
        });
     
    }


   

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.RoadmapJourney.init();
});